<template>
    <div id="app">
      <div class="app-header">
        <h1>AI对话平台</h1>
      </div>
      
      <div class="app-container">
        <div class="sidebar">
          <div class="ai-type-tabs">
            <button 
              :class="{ active: currentAiType === 'chatGLM' }"
              @click="currentAiType = 'chatGLM'"
            >
              ChatGLM
            </button>
            <button 
              :class="{ active: currentAiType === 'autoGLM' }"
              @click="currentAiType = 'autoGLM'"
            >
              AutoGLM
            </button>
            <button 
              :class="{ active: currentAiType === 'painting' }"
              @click="currentAiType = 'painting'"
            >
              绘画AI
            </button>
          </div>
          
          <div class="conversation-list-container">
            <ConversationList :aiType="currentAiType" />
          </div>
        </div>
        
        <div class="main-content">
          <ChatInterface />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import ConversationList from '@/components/ConversationList';
  import ChatInterface from '@/components/ChatInterface';
  
  export default {
    name: 'App',
    components: {
      ConversationList,
      ChatInterface
    },
    data() {
      return {
        currentAiType: 'chatGLM' // 默认选中ChatGLM
      };
    }
  };
  </script>
  
  <style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }
  
  .app-header {
    background-color: #42b983;
    color: white;
    padding: 16px;
    text-align: center;
  }
  
  .app-container {
    display: flex;
    flex: 1;
    overflow: hidden;
  }
  
  .sidebar {
    width: 350px;
    border-right: 1px solid #e0e0e0;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  
  .ai-type-tabs {
    display: flex;
    border-bottom: 1px solid #e0e0e0;
  }
  
  .ai-type-tabs button {
    flex: 1;
    padding: 12px;
    background: none;
    border: none;
    cursor: pointer;
    transition: all 0.2s;
  }
  
  .ai-type-tabs button.active {
    background-color: #f0f0f0;
    font-weight: bold;
    border-bottom: 2px solid #42b983;
  }
  
  .ai-type-tabs button:hover:not(.active) {
    background-color: #f5f5f5;
  }
  
  .conversation-list-container {
    flex: 1;
    overflow: hidden;
    padding: 8px;
  }
  
  .main-content {
    flex: 1;
    padding: 16px;
    overflow: hidden;
  }
  </style>
  